"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgTableCertified14Px = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14 }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#BFBFBF", d: "M5 4v2h2v1H5v2h1v1H5v2H4v-2H1V9h3V7H1V6h3V4h1Zm4 0v2H8V4h1Z" }),
        React.createElement("path", { fill: "#666", d: "M12 0a1 1 0 0 1 1 1v5h-1V4H1v8h5v1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h11Zm0 1H1v2h11V1Z" }),
        React.createElement("circle", { cx: 10.5, cy: 10.5, r: 3.5, fill: "#008057" }),
        React.createElement("path", { fill: "#FFF", d: "m11.787 8.54.794.437-1.98 3.608a.45.45 0 0 1-.132.147l-.073.042-.016.007a.455.455 0 0 1-.507-.083l-1.645-1.554.631-.647 1.226 1.153 1.702-3.11Z" }))));
const Memo = (0, react_1.memo)(SvgTableCertified14Px);
exports.default = Memo;
//# sourceMappingURL=TableCertified14Px.js.map